module.exports = __webpack_public_path__ + "img/29_29.d22e4db9.png";